import { defineStore } from "pinia";
import CustomStore from "devextreme/data/custom_store";
import _ from "lodash";
import axios from "axios";
import { ref } from "vue";
import { API_BASE_URL } from "@/global-constants";
import api from "@/api";
export const useDp3ListModel = defineStore("dp3ListModel", () => {
  const pegawaiFilter = ref(null);
  const filter = ref(null);
  const take = ref(null);

  const setPegawaiFilter = (e) => {
    pegawaiFilter.value = e;
  };

  const setFilter = (e) => {
    filter.value = e;
  };

  const setTake = (e) => {
    take.value = e;
  };

  function convertColumnName(name, columns) {
    for (const column of columns) {
      const pattern = new RegExp(`^${column}_`);
      if (pattern.test(name)) {
        return name.replace(pattern, `${column}.`);
      }
    }
    return name;
  }

  function convertArrayElements(arr, columns) {
    return _.map(arr, (element) => {
      if (_.isArray(element)) {
        return convertArrayElements(element, columns);
      } else if (_.isString(element)) {
        return convertColumnName(element, columns);
      }
      return element;
    });
  }

  function convertArrayTgl(loadArray) {
    _.forEach(loadArray, (item, index) => {
      if (item instanceof Date) {
        loadArray[index] = formatDateToISOString(item);
      }
    });

    return loadArray;
  }

  const dp3ListCustomStore = new CustomStore({
    key: "dp3s_id",
    insert: async (values) => {
      values = convertArrayTgl(values);
      try {
        const response = await axios.post(
          `${API_BASE_URL}/customstore-dp3s/insert`,
          { values: values },
          {
            headers: {
              Authorization: api.defaults.headers.common["Authorization"],
              "Content-Type": "application/json",
            },
          }
        );
        if (response.data) {
          return response.data.data;
        }
      } catch (error) {
        console.error("Insert error:", error);
        throw JSON.stringify(error.response.data.message, null, 2);
      }
    },
    update: async (key, values) => {
      values = convertArrayTgl(values);
      try {
        const response = await axios.post(
          `${API_BASE_URL}/customstore-dp3s/insert`,
          { values: values, id: key },
          {
            headers: {
              Authorization: api.defaults.headers.common["Authorization"],
              "Content-Type": "application/json",
            },
          }
        );
        if (response.data) {
          return response.data.data;
        }
      } catch (error) {
        console.error("Insert error:", error);
        throw JSON.stringify(error.response.data.message, null, 2);
      }
    },
    remove: async (key) => {
      try {
        const response = await axios.delete(
          `${API_BASE_URL}/customstore-dp3s/${key}`,
          {
            headers: {
              Authorization: api.defaults.headers.common["Authorization"],
              "Content-Type": "application/json",
            },
          }
        );

        if (response.data) {
          return true;
        }
      } catch (error) {
        console.error("Insert error:", error);
        throw JSON.stringify(error.response.data.message, null, 2);
      }
    },
    load: async (loadOptions) => {
      const columns = ["pegawais", "penilais", "atasan_penilais", "dp3s"];

      let params = {};
      params.sort = "";
      params.filter = "";
      if (loadOptions.sort) {
        if (typeof loadOptions.sort[0].selector === "function") {
          loadOptions.sort[0].selector =
            loadOptions.sort[0].selector.context.column.dataField;
        }
        params.sort = JSON.stringify(
          convertArrayElements(loadOptions.sort, columns)
        );
        params.sort = params.sort.replace(/bulan/g, "tgl");
      }

      if (loadOptions.filter) {
        loadOptions.filter = processLoadArray(loadOptions.filter); //benerin format tanggal
        let temp = [];

        temp = convertArrayElements(loadOptions.filter, columns);
        params.filter = JSON.stringify(temp);
        params.filter = params.filter.replace(/bulan/g, "tgl");
      }

      if (filter.value) {
        loadOptions.filter = processLoadArray(filter.value); //benerin format tanggal
        let temp = [];

        temp = convertArrayElements(loadOptions.filter, columns);
        params.filter = JSON.stringify(temp);
        params.filter = params.filter.replace(/bulan/g, "tgl");
      }

      if (pegawaiFilter.value != null) {
        params.filterPegawai = pegawaiFilter.value.trim();
      } else {
        params.filterPegawai = null;
      }

      // ================FILTER DEFAULT --> filter pegawai yang aktif
      loadOptions.filterDefault = [];
      if (params.filter === "") {
        // loadOptions.filterDefault = ['simpeg_pegawais.status_aktif_id', '=', '1'];
      }

      params.filterDefault = JSON.stringify(loadOptions.filterDefault);

      //================SORT DEFAULT --> sort jabatan_id asc, nik
      loadOptions.sortDefault = [];

      const hasOnlyTableId =
        loadOptions.sort &&
        loadOptions.sort.length === 1 &&
        _.get(loadOptions.sort[0], "selector") === "dp3s_id";

      if (params.sort === "" || hasOnlyTableId) {
        loadOptions.sortDefault.push({ selector: "tgl_awal", desc: true });
        // loadOptions.sortDefault.push({"selector":"nik","desc":false});
        // loadOptions.sortDefault.push({"selector":"pegawai_statuses.id","desc":false});
        // loadOptions.sortDefault.push({"selector":"tgl_mulai_bekerja","desc":false});
        // loadOptions.sortDefault.push({"selector":"nama","desc":false});
        params.sort = "";
      }

      params.sortDefault = JSON.stringify(loadOptions.sortDefault);

      ////////////////////////////////////

      if (loadOptions.skip) {
        params.skip = loadOptions.skip;
      }

      if (loadOptions.take && take.value !== "all") {
        params.take = loadOptions.take;
      }

      if (loadOptions.totalSummary) {
        params.summary = loadOptions.totalSummary.map(
          (summaryItem) => summaryItem.selector
        );
      }
      const response = await axios.get(`${API_BASE_URL}/customstore-dp3s`, {
        params: params,
        headers: {
          Authorization: api.defaults.headers.common["Authorization"],
          "Content-Type": "application/json",
        },
      });

      if (response.data) {
        return {
          data: response.data.data,
          totalCount: response.data.totalCount,
          summary: response.data.summary,
        };
      }

      throw "Data loading error";
    },
  });

  function processLoadArray(loadArray) {
    return _.map(loadArray, (item) => {
      if (_.isArray(item)) {
        // Check if 'periode_absen' is present in the sub-array
        if (
          _.includes(item, "tgl_mulai_bekerja") ||
          _.includes(item, "tgl_lahir") ||
          _.includes(item, "pensiun_tgl")
        ) {
          // Map through the sub-array to find and convert Date objects
          return _.map(item, (subItem) => {
            return subItem instanceof Date
              ? formatDateToISOString(subItem)
              : subItem;
          });
        } else {
          // Recursively process nested arrays
          return processLoadArray(item);
        }
      }
      return item;
    });
  }

  function formatDateToISOString(date) {
    function pad(n) {
      return n < 10 ? "0" + n : n;
    }
    return (
      date.getFullYear() +
      "-" +
      pad(date.getMonth() + 1) +
      "-" +
      pad(date.getDate())
    );
  }

  return {
    dp3ListCustomStore,
    pegawaiFilter,
    setPegawaiFilter,
    filter,
    setFilter,
    take,
    setTake,
  };
});
